//Constants defining keys for loading states in Page.Content Component.
export const LOADING_KEYS = {
  AUTO_PAYMENTS_KEY: 'autoPayments',
  BULK_PAYMENTS_KEY: 'bulkPayments',
  BALANCE_DETAILS_KEY: 'balanceDetails',
  BULK_ONE_TIME_PAYMENTS_KEY: 'bulkOneTimePayments',
  BULK_ONETIME_PAYMENTS_KEY: 'bulk_one_time_payments',
  FUTURE_CHARGES_KEY: 'futureCharges',
  MAKE_PAYMENT_KEY: 'makePayment',
  PAYMENTS_KEY: 'payments',
  PAYMENT_METHODS_KEY: 'paymentMethods',
  PLAID_OAUTH_KEY: 'plaidOauth',
  REFUND_METHOD_KEY: 'refundMethod',
  REQUEST_PAYMENT_METHODS_KEY: 'requestPaymentMethods',
}

//Constants defining amount options for BiMonthly Form Component.
export const AMOUNT_OPTIONS = {
  HALF: 'half_balance',
  OTHER: 'other_amount',
}

//Constants defining card type IDs for Payment Method Components.
export const CARD_TYPE_IDS = [5, 6, 7, 8]

// Define convenience fees for different card types and networks
export const APPLE_PAY_CARD_CONVINIENCE_FEES = {
  credit: 0, // Default fee for other credit cards
  debit: 0, // Default fee for other debit cards
}

// Define Apple Event Attach From
export const ATTACH_APPLE_PAY_ENVENT_FROM = {
  ONE_TAP_FORM: 'ONE_TAP_FORM',
  DUPLICATE_PAYMENT_POUP: 'DUPLICATE_PAYMENT_POUP-MODAL',
}

//Define Canada country code
export const CANADA_COUNTRY = 'CA'
